module.exports = __webpack_public_path__ + "static/img/network-06.def0317.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/register/network/network-06.jpg
// module id = BU7S
// module chunks = 1